import { IDerivedViewList } from "src/models";
import { cdataFetch } from "../cdataFetch";

export function getDerivedViews() {
  return cdataFetch<IDerivedViewList>({
    method: "GET",
    url: "/account/derivedViews",
  });
}
